import { isValidServiceOption } from "@/lib/services/isValidOption"

export const extractServiceFromQuery = (query: { specialty?: string }) => {
  const specialty = query.specialty

  if (isValidServiceOption(specialty)) {
    return specialty
  }
}
